import { FontIcon, mergeStyles, Stack } from "@fluentui/react";
import { FunctionComponent } from "react";
import { helperFont } from "../../utils/helpers/helpers";
import COLORES from "../../utils/theme/colores";

interface DefaultSelectProps {
    iconName?: string
}

const iconClass = mergeStyles({
    fontSize: 50,
    height: 50,
    width: 50,
    margin: '0 25px',
});

const StyleIcon = mergeStyles(iconClass, {
    fill: 'red',
    selectors: {
        '.thing': {
            fill: 'green',
        },
    },
})

const DefaultSelect: FunctionComponent<DefaultSelectProps> = (props = { iconName: "Pinned" }) => {
    return (
        <>
            <div className="ms-Grid-col ms-md9 ms-lg9">
                <div style={{ paddingRight: 1 }}>
                    <Stack
                        verticalAlign="center"
                        horizontalAlign="center"
                        styles={{
                            root: {
                                height: 'calc(100vh - 6.5em)',
                                background: COLORES.Bases.BackgroundToDo
                            }
                        }}
                    >
                        <FontIcon
                            aria-label="Yammer logo"
                            iconName={props.iconName}
                            className={StyleIcon}
                        />
                        <br />
                        <p style={{ ...helperFont, margin: 2 }}>Seleccione un elemento para ver detalle</p>
                        <p style={{ ...helperFont, color: COLORES.Bases.neutralSecondaryAlt }}>No hay nada seleccionado</p>
                    </Stack>
                </div>
            </div>
        </>
    );
}

export default DefaultSelect;